namespace PaperTrail.NewsletterControl {
    export interface StoryForm {
        UserId: Serenity.LookupEditor;
        NewslettersList: Serenity.LookupEditor;
        DateSubmitted: Serenity.DateEditor;
        DateModified: Serenity.DateEditor;
        DatePublished: Serenity.DateEditor;
        Title: Serenity.StringEditor;
        Subtitle: Serenity.StringEditor;
        StoryBlocks: StoryTextBlockEditor;
        StoryImages: StoryImageEditor;
        Page: Serenity.IntegerEditor;
        Position: Serenity.IntegerEditor;
        Characters: Serenity.IntegerEditor;
        DoPageBreak: Serenity.BooleanEditor;
        Rows: Serenity.IntegerEditor;
        Columns: Serenity.IntegerEditor;
        StyleSheetId: Serenity.LookupEditor;
        Rank: Serenity.IntegerEditor;
    }

    export class StoryForm extends Serenity.PrefixedContext {
        static formKey = 'NewsletterControl.Story';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StoryForm.init)  {
                StoryForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = StoryTextBlockEditor;
                var w4 = StoryImageEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.BooleanEditor;

                Q.initFormType(StoryForm, [
                    'UserId', w0,
                    'NewslettersList', w0,
                    'DateSubmitted', w1,
                    'DateModified', w1,
                    'DatePublished', w1,
                    'Title', w2,
                    'Subtitle', w2,
                    'StoryBlocks', w3,
                    'StoryImages', w4,
                    'Page', w5,
                    'Position', w5,
                    'Characters', w5,
                    'DoPageBreak', w6,
                    'Rows', w5,
                    'Columns', w5,
                    'StyleSheetId', w0,
                    'Rank', w5
                ]);
            }
        }
    }
}
